<template>
    <div class="app-body">
        <bread-crumb></bread-crumb>
        <el-card class="editWarningUser">
            <el-form :model="form" ref="form" :rules="rules" label-width="140px" label-position="left">
                <el-form-item label="站点" prop="stationId">
                    <le-select-remote-search 
                        v-if="editType=='add'"
                        class="formInput" 
                        label="" 
                        v-model="form.stationId" 
                        :options="stationFilterOptions" 
                        :defaultOptions='defaultStationOptions'
                        placeholder="请选择" />
                    <span v-else>{{ form.stationName || '-' }}</span>
                </el-form-item>
                <el-form-item label="工程商户" prop="companyId">
                    <le-select-remote-search 
                        v-if="editType=='add'"
                        class="formInput" 
                        label="" 
                        v-model="form.companyId" 
                        :options="companyFilterOptions" 
                        placeholder="请选择" />
                    <span v-else>{{ form.companyName || '-' }}</span>
                </el-form-item>
                <el-form-item label="工程款类型" prop="paymentType">
                    <el-radio-group v-model="form.paymentType" v-if="editType!='info'">
                        <el-radio :label="1">预估</el-radio>
                        <el-radio :label="2">实际</el-radio>
                    </el-radio-group>
                    <span v-else>{{ form.paymentType == 1 ? '预估' : form.paymentType == 2 ? '实际' : '-' }}</span>
                </el-form-item>
                <el-form-item label="工程款" prop="payment">
                    <jd-input-price v-if="editType!='info'" v-model="form.payment" style="width:240px"></jd-input-price>
                    <span v-else>￥{{ form.payment || '-' }}</span>
                </el-form-item>
                <el-form-item label="回收前分配比例" prop="beforeRate">
                    <el-input 
                        v-if="editType!='info'"
                        v-model="form.beforeRate" 
                        maxlength="6" 
                        @input="form.beforeRate = util.checkMoney(form.beforeRate)" 
                        style="width:240px" 
                        placeholder="请输入">
                        <template slot="append">%</template>
                    </el-input>
                    <span v-else>{{ form.beforeRate || '-' }}%</span>
                </el-form-item>
                <el-form-item label="回收后分配比例" prop="afterRate">
                    <el-input 
                        v-if="editType!='info'"
                        v-model="form.afterRate" 
                        maxlength="6" 
                        @input="form.afterRate = util.checkMoney(form.afterRate)" 
                        style="width:240px" 
                        placeholder="请输入">
                        <template slot="append">%</template>
                    </el-input>
                    <span v-else>{{ form.afterRate || '-' }}%</span>
                </el-form-item>
            </el-form>
            <div style="height: 100px;"></div>
            <div class="a-line-t-e0 footerBox">
                <el-button type="primary" class="a-ml-24 a-mt-15" @click="submit" v-if="editType!='info'">立即提交</el-button>
                <el-button class="a-ml-24 a-mt-15" style="margin-left: 24px" @click="cancelSubmit">&nbsp;&nbsp;&nbsp;返回&nbsp;&nbsp;&nbsp;</el-button>
            </div>
        </el-card>
    </div>
</template>

<script>
    import util from '@/utils/util'
    export default {
        data() {
            var checkRate = (rule, value, callback) => {
                let rate = Number(value)
                if(rate > 100){
                    callback(new Error('分配比列不得大于100%'))
                }else{
                    callback()
                }
            };
            return {
                util,
                id: '',
                editType: '',
                form: {
                    afterRate: '',
                    beforeRate: '',
                    companyId: '',
                    payment: '',
                    paymentType: 1,
                    stationId: ''
                },
                rules: {
                    afterRate: [{required: true, message:'请输入回收后分配比例', trigger: 'blur'},{ validator: checkRate, trigger: 'blur' }],
                    beforeRate: [{required: true, message:'请输入回收前分配比例', trigger: 'blur'},{ validator: checkRate, trigger: 'blur' }],
                    companyId: [{required: true, message:'请选择工程商户', trigger: 'blur'}],
                    payment: [{required: true, message:'请输入工程款', trigger: 'blur'}],
                    paymentType: [{required: true, message:'请选择工程款类型', trigger: 'blur'}],
                    stationId: [{required: true, message:'请选择站点', trigger: 'blur'}]
                },
                companyFilterOptions: {
                    url: this.$Config.apiUrl.getUnderCompany,
                    method: "post",
                    params: {
                        companyType: 3,
                        isSignAgency: 1,
                    },
                    showLoading: false,
                    labelKey: "name",
                    valueKey: "id",
                    searchKey: "name",
                    pageSize: 100
                },
                stationFilterOptions: {
                    url: this.$Config.apiUrl.getStationList,
                    method: "post",
                    params: {
                        incomeId: ''
                    },
                    showLoading: false,
                    labelKey: "name",
                    valueKey: "stationId",
                    searchKey: "name",  //incomeDistriId
                    pageSize: 100
                },//站点数据
                defaultStationOptions: [],
                defaultCompanyOptions: []
            };
        },
        created () {
            this.id = this.$route.query.id
            this.editType = this.$route.query.type
            if(this.id) this.getDetails()
        },
        computed: {
            
        },
        mounted () {
            
        },
        methods: {
            // 查询详情
            getDetails () {
                this.$Axios._post({
                    url: this.$Config.apiUrl.engineerInfo,
                    method: "post",
                    params: {
                        id: this.id
                    },
                })
                .then(res=>{
                    let datas = res.result.data
                    this.form = {
                        ...datas,
                        afterRate: datas.afterRate?this.$decimal.decimal_except(datas.afterRate,100):0,
                        beforeRate: datas.beforeRate?this.$decimal.decimal_except(datas.beforeRate,100):0,
                        payment: datas.payment?this.$decimal.decimal_except(datas.payment,100):0,
                    }
                    this.defaultStationOptions = [{
                        id: datas.stationId,
                        name: datas.stationName
                    }]
                    this.defaultCompanyOptions = [{
                        id: datas.companyId,
                        name: datas.companyName
                    }]
                })
                .catch(err=>{
                    console.log(err);
                })
            },
            submit () {
                this.$refs['form'].validate(async (valid) => {
                    if (valid) {
                        this.$confirm('是否确认提交？', '温馨提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(_=>{
                            let reqData = {
                                ...this.form,
                                id: this.id,
                                afterRate: this.form.afterRate?this.$decimal.decimal_ride(this.form.afterRate,100):0,
                                beforeRate: this.form.beforeRate?this.$decimal.decimal_ride(this.form.beforeRate,100):0,
                                payment: this.form.payment?this.$decimal.decimal_ride(this.form.payment,100):0,
                            }
                            this.$Axios._post({
                                url: this.$Config.apiUrl.engineerEdit,
                                method: "post",
                                params: reqData,
                            })
                            .then(res=>{
                                if (res.result.code == 0) {
                                    this.$message.success('操作成功')
                                    this.$router.back()
                                    this.$store.dispatch("delView", this.$route);
                                } else {
                                    this.$message.error(res.result.message)
                                }
                            })
                            .catch(err=>{

                            })
                        }).catch(err=>{ console.log(err); })
                    }
                })
                
            },
            cancelSubmit () {
                this.$confirm('是否确认返回？','温馨提示')
                .then(_=>{
                    this.$router.back()
                    this.$store.dispatch("delView", this.$route);
                })
                .catch(_=>{})
            },
        },
    }
</script>

<style lang="scss" scoped>
    .editWarningUser{
        font-size: 14px;
        height: 100%;
        overflow-y: auto;
        .formInput{
            padding: 0 !important;
            width: 400px;
            /deep/ &>div{
                margin-left: 0 !important;
            }
            /deep/ .el-input__inner{
                width: 100% !important;
            }
        }
    }
</style>